import React from "react";


export default React.createContext({
   isDrawerOpen: false,
   onDrawerClose: () => {},
   onDrawerOpen: () => {},
});
